// Expectation-setter for ML-driven features whose accuracy genuinely varies
// (face detection, on-device speech-to-text) — not an error/warning state,
// just a quiet "this is still new" signal. Deliberately not amber: this
// codebase did a full sweep to remove amber everywhere (see project memory),
// so this stays in the existing slate/indigo neutral palette instead.
export function BetaBadge({ className = '' }: { className?: string }) {
  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 rounded-full bg-slate-100 text-slate-500 text-[10px] font-bold uppercase tracking-wide ${className}`}
    >
      Beta
    </span>
  );
}
